import { render } from "./NTextareaAutosize.vue?vue&type=template&id=a710a266&ts=true"
import script from "./NTextareaAutosize.vue?vue&type=script&lang=ts"
export * from "./NTextareaAutosize.vue?vue&type=script&lang=ts"

import "./NTextareaAutosize.vue?vue&type=style&index=0&id=a710a266&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__